import type { Organization } from 'src/types/organization';
import type { RoleKey } from 'src/types/rules';

import rbacCheck from '../../../rbac/rbacCheck';

const useLayoutPermissions = (roles: RoleKey[], organization: Organization | undefined) => {
  const checkPermission = (action: string, data?: unknown): boolean => {
    try {
      return rbacCheck(roles, action, data) as boolean;
    } catch (error) {
      console.error('RBAC check failed:', error);
      return false;
    }
  };

  return {
    canSeeOrganizationProducts: checkPermission('/products:VIEW', organization),
    canSeeProducts: checkPermission('/products', organization),
    canSeeOrganizations: checkPermission('/organizations:VIEW_ALL'),
    canSeeOwnOrganization: checkPermission('/organizations:VIEW_OWN_DETAILS'),
    canOrderCompute: checkPermission('/products/compute/order', organization),
    canSeeReports: checkPermission('/reports'),
    canSeeUsers: checkPermission('/users:VIEW'),
    canSeeProjects: checkPermission('/projects:VIEW'),
    hasComputeActivated:
      organization?.marketplaceItems?.some(item => item.name === 'Compute') ?? false,
    hasEvaluationActivated:
      organization?.marketplaceItems?.some(item => item.name === 'Evaluation') ?? false,
    hasCaasActivated:
      organization?.marketplaceItems?.some(
        item => item.name === 'CaaSonBareMetal' || item.name === 'CaaSonOpenstack'
      ) ?? false,
    hasBareMetalActivated:
      organization?.marketplaceItems?.some(item => item.name === 'BareMetal') ?? false,
    canSeeOnboardingUsers: checkPermission('/onboarding/admin-review'),
  };
};

export default useLayoutPermissions;
